module.exports = __webpack_public_path__ + "img/rope-cleaning-farrer-glass.7a5873f8.jpg";